// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"ButtonSeeProject_moreInfo__f1Sta","open":"ButtonSeeProject_open__RZk8s","text":"ButtonSeeProject_text__3oa5E","svg":"ButtonSeeProject_svg__1wy4G"};